/** 휴대폰 일반결제 페이지 오픈 타입 */
export const MobilePaymentOpen = {
    POPUP: 'popup',
    SELF: 'self',
} as const

export type MobilePaymentOpenType = Constant<typeof MobilePaymentOpen>

/** 휴대폰 일반결제 프로세스 진행 상태 */
export const MobilePaymentStatus = {
    IDLE: 'IDLE',
    PROCESSING: 'PROCESSING',
    SUCCEED: 'SUCCEED',
    FAILED: 'FAILED',
} as const

export type MobilePaymentStatusType = Constant<typeof MobilePaymentStatus>
